module.exports = __webpack_public_path__ + "img/PoolListTableIcon.a96d254a.svg";